import React from 'react';
import {useSelector} from 'react-redux';

import {LegacyAssaySchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingState} from 'redux-stores/reduceApp';
import DuplicateRunSchemaButton from 'runs/run-schemas/DuplicateRunSchemaButton';
import {SCHEMA_TYPES} from 'schemas/spec/SchemaConfigConstants';

interface AssaySchemaDuplicateRunSchemaButtonProps {
  schemaId: string;
  schemaType: keyof typeof SCHEMA_TYPES;
  isSpecJsonFormat: boolean;
}

export default function AssaySchemaDuplicateRunSchemaButton(
  props: AssaySchemaDuplicateRunSchemaButtonProps
): JSX.Element | null {
  const sessionId = useSelector((state: BenchlingState) => state.ui.schemaConfig.sessionId);
  const hasUnsavedData = useSelector((state: BenchlingState) => state.ui.schemaConfig.hasUnsavedData);
  const inputFileConfigs = useSelector((state: BenchlingState) => state.ui.schemaConfig.inputFileConfigs);
  const outputFileConfigs = useSelector((state: BenchlingState) => state.ui.schemaConfig.outputFileConfigs);

  if (props.schemaType !== LegacyAssaySchemaType.ASSAY_RUN) {
    return null;
  }

  return (
    <DuplicateRunSchemaButton
      schemaId={props.schemaId}
      hasUnsavedData={hasUnsavedData}
      sessionId={sessionId}
      isSpecJsonFormat={props.isSpecJsonFormat}
      inputFileConfigs={inputFileConfigs}
      outputFileConfigs={outputFileConfigs}
    />
  );
}
